import React, { useEffect } from "react";

import "./calenderView.scss";
import "../../../../style/main.scss";
import KPICards from "./components/KPICards";
import DayCalenderViewPage from "./components/dayCalenderViewPage";
import MonthCalenderViewPage from "./components/monthCalenderViewPage";
import { useCalenderViewStore } from "@stores/useCalenderViewStore";
import DrillDownView from "./components/DrillDownView";

const CalenderView = (props: any) => {
  const viewForCalender = useCalenderViewStore((state) => state.viewForCalender);
  const isDrillDownViewSelected = useCalenderViewStore((state) => state.isDrillDownViewSelected);
  const setIsDrillDownViewSelected = useCalenderViewStore((state) => state.setIsDrillDownViewSelected);
  const isProfileView = useCalenderViewStore((state) => state.isProfileView);
  const setViewForCalender = useCalenderViewStore((state) => state.setViewForCalender);
  // const [viewForCalender, setViewForCalender] = useState(false);

  useEffect(() => {
    console.log("CalenderView.useEffect");
    if (isDrillDownViewSelected) {
      setIsDrillDownViewSelected(false);
    }
    setViewForCalender(false);
  }, [setIsDrillDownViewSelected, setViewForCalender]);
  return (
    <>
      {!isDrillDownViewSelected ? (
        <div className="ui-calenderView-container">
          <KPICards />
          {viewForCalender ? <DayCalenderViewPage /> : <MonthCalenderViewPage />}
        </div>
      ) : (
        <DrillDownView isProfileView={isProfileView} />
      )}
    </>
  );
};

export default CalenderView;
